import { TENANTS } from "../../../constants"
import { isPdiRetailTenant, loc } from "../../../core/utils"
import { PackServiceContext } from "../../../digital-journey/ServicePage/context/PackServiceContext"
import { withUpdatedTunnelData } from "../../../digital-journey/hoc/withUpdatedTunnelData"
import useCreateOrder from "../../../hooks/useCreateOrder"
import DynamicLogo from "../../atoms/DynamicLogos/DynamicLogo"
import Basket from "../Basket"
import HeaderLanguageSelector from "../HeaderLanguageSelector/HeaderLanguageSelector"
import LogoutButton from "./LogoutButton"
import TopbarBasketPrice from "./TopbarBasketPrice"
import React, { useContext, useState } from "react"
import { Button, Col, Container, Nav, Navbar, Row } from "react-bootstrap"

const Topbar = ({ tunnelData, history, displayToggleButton = true }) => {
  const { data, tenant, brandLogo } = tunnelData
  const [isBasketOpen, setIsBasketOpen] = useState(false)

  const { packContext } = useContext(PackServiceContext)
  const UpdatedTunnelDataBasket = withUpdatedTunnelData(Basket, tunnelData, packContext)
  const { createOrder, showBasket, showCreateOrderButton } = useCreateOrder({ tunnelData })

  const onToggleBasket = (nextOpen) => {
    setIsBasketOpen(nextOpen)
    document.body.style.position = nextOpen ? "fixed" : ""
  }

  function formatPrice(price) {
    return tenant === TENANTS.SAMSUNG_NL ? `€${price}` : `${price}€`
  }

  const getHomeUrl = (tenant) => (isPdiRetailTenant(tenant) ? `${tunnelData.pdiRetailUrl}home` : "#home")

  return (
    <Col sm={12} className="topbar-container">
      {isBasketOpen && (
        <div
          className="basket-backdrop d-lg-none"
          onMouseDown={(event) => {
            event.preventDefault()
            onToggleBasket(false)
          }}
          onTouchStart={(event) => {
            event.preventDefault()
            onToggleBasket(false)
          }}
          aria-hidden="true"
        />
      )}
      <Navbar
        className="d-flex d-lg-none justify-content-between"
        collapseOnSelect
        expand="lg"
        fixed="top"
        expanded={isBasketOpen}
        onToggle={onToggleBasket}
      >
        {tunnelData.hideLogo?<></>:<Navbar.Brand className="topbar-logo" href={getHomeUrl()}>
          <DynamicLogo tenant={tenant} brandLogo={brandLogo} />
        </Navbar.Brand>}


        <div className="d-flex gap-1 justify-content-end ml-auto mr-4">
          {displayToggleButton && showBasket && (
            <Navbar.Toggle aria-controls="responsive-navbar-nav">
              {tunnelData?.displayHeaderPrice && data?.order?.rent && tenant && (
                <TopbarBasketPrice rent={data?.order?.rent} tenant={tenant} formatPrice={formatPrice} />
              )}
              <span className="navbar-toggler-icon" />
              <span className={`header_icon fa fa-angle-down${isBasketOpen ? " is-open" : ""}`} aria-hidden="true" />
            </Navbar.Toggle>
          )}

          <HeaderLanguageSelector />
          <LogoutButton tunnelData={tunnelData} />
        </div>

        <Navbar.Collapse id="responsive-navbar-nav" className="basket-collapse">
          <Nav className={`mr-auto ${showCreateOrderButton ? "mb-4" : ""}`}>
            {tunnelData.tenant !== TENANTS.RETAIL_BPLS && <UpdatedTunnelDataBasket />}
          </Nav>
          {showCreateOrderButton && (
            <Button variant="success" className="submit position-absolute fixed-bottom" onClick={() => createOrder()}>
              {loc("Validate")}
            </Button>
          )}
        </Navbar.Collapse>
      </Navbar>
      {tunnelData.hideLogo?<></>:
      <Container
        className="topbar d-none d-lg-block"
        style={
          tunnelData.tenant === TENANTS.BPLS && window.location.pathname === "/digital-journey/onboarding"
            ? { paddingLeft: 0 }
            : {}
        }
      >

        <Row className="align-items-center">
          <Col className="topbar-logo">
            <DynamicLogo tenant={tenant} brandLogo={brandLogo} />
          </Col>
          <Col xs="auto" className="d-flex gap-2 align-items-center">
            <HeaderLanguageSelector />
            <LogoutButton tunnelData={tunnelData} />
          </Col>
        </Row>
      </Container>
      }
    </Col>
  )
}

export default Topbar
